"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumScreenName = void 0;
/**
 * The unique screen name that the event was sent from. This is also used as part of the event name for screen view events.
 * @export
 * @enum {string}
 */
exports.EnumScreenName = {
    CircleCreation: 'CircleCreation',
    Eligibility: 'Eligibility',
    EnterAccessCode: 'EnterAccessCode',
    ChangeOfSponsorship: 'ChangeOfSponsorship',
    RegistrationConfirmed: 'RegistrationConfirmed',
    RegistrationCountry: 'RegistrationCountry',
    RegistrationNotConfirmed: 'RegistrationNotConfirmed',
    SkipAccessCode: 'SkipAccessCode',
    SkipEligibility: 'SkipEligibility',
    VideoPlayer: 'VideoPlayer',
    CarePlan: 'CarePlan',
    CarePlanAllRecommendations: 'CarePlanAllRecommendations',
    Consent: 'Consent',
    ConvertToDtcConfirmation: 'ConvertToDtcConfirmation',
    DemoAccountExpired: 'DemoAccountExpired',
    Discover: 'Discover',
    DiscoverCategory: 'DiscoverCategory',
    DiscoverGoal: 'DiscoverGoal',
    DiscoverTopic: 'DiscoverTopic',
    DiscoverClinical: 'DiscoverClinical',
    Error: 'Error',
    Expired: 'Expired',
    HipaaAuthorization: 'HipaaAuthorization',
    Home: 'Home',
    HomeLibrary: 'HomeLibrary',
    HomeLibraryViewAllFavorites: 'HomeLibraryViewAllFavorites',
    HomeLibraryViewAllRecentlyPlayed: 'HomeLibraryViewAllRecentlyPlayed',
    HomeLibraryViewAllCompleted: 'HomeLibraryViewAllCompleted',
    Landing: 'Landing',
    Login: 'Login',
    LoginScreen: 'LoginScreen',
    LoginRegistration: 'LoginRegistration',
    LossOfSponsorshipBlocker: 'LossOfSponsorshipBlocker',
    NpsPoll: 'NpsPoll',
    PartnerAuthorization: 'PartnerAuthorization',
    Profile: 'Profile',
    Search: 'Search',
    Settings: 'Settings',
    Signup: 'Signup',
    Sponsor: 'Sponsor',
    ProgramDetail: 'ProgramDetail',
    NotMapped: 'NotMapped',
    SponsorUpdatedSuccess: 'SponsorUpdatedSuccess',
    StandaloneScreening: 'StandaloneScreening',
    StandaloneScreeningResults: 'StandaloneScreeningResults',
    NonUsResidentBlocker: 'NonUSResidentBlocker',
    WelcomeBack: 'WelcomeBack',
    Registration: 'Registration',
    Saml: 'Saml',
    SsoIn: 'SsoIn',
    SsoInFocus: 'SsoInFocus',
    Health: 'Health',
    NotFound: 'NotFound',
    LoggedOut: 'LoggedOut',
    AudioPlayer: 'AudioPlayer',
    AuthorBio: 'AuthorBio',
    CategoryFeed: 'CategoryFeed',
    CheckIn: 'CheckIn',
    ClinicalProgram: 'ClinicalProgram',
    ClinicalProgramOverview: 'ClinicalProgramOverview',
    CreateHabits: 'CreateHabits',
    CrisisLifeline: 'CrisisLifeline',
    Conditions: 'Conditions',
    ConditionSearch: 'ConditionSearch',
    DailiesFeed: 'DailiesFeed',
    DailyDetail: 'DailyDetail',
    DebugButtonComponents: 'DebugButtonComponents',
    DebugDynamicLinks: 'DebugDynamicLinks',
    DebugInputComponents: 'DebugInputComponents',
    DebugMain: 'DebugMain',
    DebugRemoteConfig: 'DebugRemoteConfig',
    DebugSharedPref: 'DebugSharedPref',
    DebugTestScreen: 'DebugTestScreen',
    DebugTextComponents: 'DebugTextComponents',
    DebugThemeComponents: 'DebugThemeComponents',
    EditProfile: 'EditProfile',
    FtueSurveyEnd: 'FtueSurveyEnd',
    FtueSurveyQuestion: 'FtueSurveyQuestion',
    FtueSurveyStart: 'FtueSurveyStart',
    FtueSurveyResults: 'FtueSurveyResults',
    GoalSelection: 'GoalSelection',
    LearnWhyScreen: 'LearnWhyScreen',
    MentalHealthSurveyEnd: 'MentalHealthSurveyEnd',
    MentalHealthSurveyQuestion: 'MentalHealthSurveyQuestion',
    MentalHealthSurveyStart: 'MentalHealthSurveyStart',
    MentalHealthSurveyResults: 'MentalHealthSurveyResults',
    NarratorBio: 'NarratorBio',
    TopicSelection: 'TopicSelection',
    FriendsAndFamily: 'FriendsAndFamily',
    DependentInviteManage: 'DependentInviteManage',
    DependentInvitedSuccessModal: 'DependentInvitedSuccessModal',
    DependentRegistrationCountry: 'DependentRegistrationCountry',
    DependentRegistrationLinkExpired: 'DependentRegistrationLinkExpired',
    DependentUpdateSponsorshipSuccess: 'DependentUpdateSponsorshipSuccess',
    DependentRegistrationError: 'DependentRegistrationError',
    DependentRegistrationCountryError: 'DependentRegistrationCountryError',
    Invite: 'Invite',
    InvitePending: 'InvitePending',
    InviteExpired: 'InviteExpired',
    InviteClaimed: 'InviteClaimed',
    InviteResend: 'InviteResend',
    Notifications: 'Notifications',
    EmailOptionPreferences: 'EmailOptionPreferences',
    EmailPreferencesConfirmed: 'EmailPreferencesConfirmed',
    AgeAndGender: 'AgeAndGender',
};
//# sourceMappingURL=enum-screen-name.js.map